import React, { Component } from "react";
import classes from "./LessonCard.module.css";
import LessonCardIcon from "../../../assets/img/LessonCard.svg";
import LessonCardCheckIcon from "../../../assets/img/MediaCheck.svg";
import LessonCardCloudIcon from "../../../assets/img/MediaCloud.svg";
import VerticalMoreOptionsIcon from "../../../assets/img/VerticalMoreOptions.svg";
import Tooltip from "@material-ui/core/Tooltip";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import { setBoardInfo } from "../../../utils/authentication-access";
import { Mixpanel } from "../../../utils/mixpanel";
import LiveClassCardLogo from "../../../assets/gif/liveclass.gif";
import { withTranslation } from 'react-i18next';

class LessonCard extends Component {
  state = {
    lessonCardMenu: null,
  };
  handleMenuClick = (event) => {
    event.stopPropagation();
    this.setState({ lessonCardMenu: event.currentTarget });
  };

  handleMenuClose = (event) => {
    event.stopPropagation();
    this.setState({ lessonCardMenu: null });
  };

  gotoClass = () => {
    this.setState({ lessonCardMenu: null });
    setBoardInfo(this.props.boardinfo);
    if (this.props.boardinfo.isOnline) {
      Mixpanel.track("Live Lesson Clicked");
    }
    if (!this.props.boardinfo.isOnline) {
      Mixpanel.track("Lesson Opened");
    }
    this.props.history.push("/class");
  };

  render() {
    const { t } = this.props;
    return (
      <>
        <div className={classes.Card} onClick={this.gotoClass}>
          {/* Card Image */}
          <div className={classes.CardImageWrapper}>
            <img
              src={
                this.props.boardinfo.isOnline
                  ? LiveClassCardLogo
                  : LessonCardIcon
              }
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderTopLeftRadius: "2px",
                borderTopRightRadius: "2px",
              }}
              alt="Lesson-Plan-Img"
            />
            {this.props.boardinfo.isOnline ? (
              <></>
            ) : (
                <img
                  src={
                    this.props.boardinfo.isPublic
                      ? LessonCardCheckIcon
                      : LessonCardCloudIcon
                  }
                  alt="Checked"
                  style={{ position: "absolute", right: "1vw", top: "-1px" }}
                />
              )}
          </div>
          {/* Card Description */}
          <div className={classes.CardDescription}>
            <Tooltip title={this.props.boardinfo.name}>
              <p
                className={[classes.CardDescriptionText, "TextDarkGrey"].join(
                  " "
                )}
              >
                {this.props.boardinfo.name}
              </p>
            </Tooltip>
            <div
              className={[classes.CardDescriptionOptions, "TextDarkGrey"].join(
                " "
              )}
              aria-controls="lesson-card-menu"
              aria-haspopup="true"
              onClick={this.handleMenuClick}
            >
              <img src={VerticalMoreOptionsIcon} alt="options" />
            </div>
          </div>
        </div>

        {/* Menu  */}
        <Menu
          id="lesson-card-menu"
          anchorEl={this.state.lessonCardMenu}
          keepMounted
          open={Boolean(this.state.lessonCardMenu)}
          onClose={this.handleMenuClose}
        >
          <MenuItem onClick={this.gotoClass}>{t("Open")}</MenuItem>
        </Menu>
      </>
    );
  }
}

export default withTranslation()(LessonCard);
